export default __webpack_public_path__ + "static/media/downArrow.f055666f.svg";